// Tiny cookie helpers. Only small preference payloads belong here — cookies are
// capped at ~4KB and are sent with every request to the API.

export const REPORT_PREFS_COOKIE = "celg_report_prefs";

export const setCookie = (name, value, days = 30) => {
  try {
    const encoded = encodeURIComponent(JSON.stringify(value));
    document.cookie = `${name}=${encoded}; path=/; max-age=${days * 24 * 60 * 60}; SameSite=Lax`;
  } catch (error) {
    // A full cookie jar or a disabled-storage browser must not break the page.
    console.error("Unable to write cookie", name, error);
  }
};

export const getCookie = (name) => {
  try {
    const match = document.cookie.split("; ").find((entry) => entry.startsWith(`${name}=`));

    if (!match) return null;

    return JSON.parse(decodeURIComponent(match.slice(name.length + 1)));
  } catch (error) {
    // Malformed or hand-edited cookie: behave as if nothing was stored.
    return null;
  }
};
